import clsx from "clsx";
import ISMSImg from "../../assets/img/ISMS.png";
import ISOImg from "../../assets/img/ISO.png";
import { ISMS_URL } from "../../types/common";

type Props = {
  ISMSImgSizePixel?: number;
  ISOImgWidthPixel?: number;
  direction?: "horizontal" | "vertical";
  fontSize?: "text-xs" | "text-sm" | "text-md" | "text-lg" | "text-xl";
  className?: string;
};

export default function Isms({
  ISMSImgSizePixel = 70,
  ISOImgWidthPixel = 100,
  direction = "horizontal",
  fontSize = "text-xs",
  className,
}: Props) {
  const directionCss = {
    "flex-col": direction !== "horizontal",
    "flex-row": direction === "horizontal",
  };

  const handleClickISMS = () => {
    window.open(ISMS_URL);
  };

  return (
    <div
      className={clsx(
        "flex w-full justify-center gap-3 items-center p-3",
        directionCss,
        className
      )}
      data-testid={"ISMS-box"}
    >
      <div
        className="flex flex-shrink-0"
        style={{
          width: ISMSImgSizePixel,
          height: ISMSImgSizePixel,
        }}
        onClick={handleClickISMS}
        data-testid={"ISMS-logo"}
      >
        <img src={ISMSImg} className="w-full h-full object-cover" />
      </div>
      <div
        className={clsx("flex flex-col text-gray-500 gap-1", fontSize)}
        onClick={handleClickISMS}
      >
        <div className="flex flex-col">
          <div>인증범위: S&I 대외 운영 서비스</div>
          <div>(샌디앱, 홈페이지, atG, 통근버스)</div>
        </div>

        <div>유효기간 : 2024.07.17 ~ 2027.07.16</div>
      </div>

      <div
        className="flex flex-shrink-0"
        style={{
          width: ISOImgWidthPixel,
        }}
        data-testid={"ISO-content"}
      >
        <img src={ISOImg} className="w-full h-full object-contain" />
      </div>
    </div>
  );
}
